module.exports = __webpack_public_path__ + "static/media/insuranceNumbersMobile.ab1042c6.png";